module.exports = __webpack_public_path__ + "img/spray-coater.9f13b7b8.png";